module.exports = __webpack_public_path__ + "1197d5f1fc7f340923c0cac3587e8396.svg";